<template>
    <sections>
        <section-job v-if="details !== null" :job="details"></section-job>
        <loading-spinner v-else></loading-spinner>
        <section-text
            v-if="details !== null"
            color="bg-zinc-50"
            heading="Interested?"
            content="<p>To apply for this job please contact your local branch.</p>"
            buttonText="Contact Us"
            buttonRoute="/contact"
            :textCentered="false"
        ></section-text>
    </sections>
</template>

<script setup>
const $route = useRoute();

const {job} = storeToRefs(useJobsStore());
const details = computed(() => {
    return job.value($route.params.jobSlug);
});

function buildHead(job) {
    if (!job?.id_job) return;
    return useSeo().buildHead({
        title: job.job_title + ' | Jobs',
        description: 'View details of this job on our website.',
        index: true,
    });
}

buildHead(details.value);
</script>
